// @ vendor
const React = require('react');
const classnames = require('classnames');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');

// @ constant
const { SECOND_STEP, THIRD_STEP } = require('constants/index');
const { EURO_TEXT } = require('constants/index');
const { PLANS: { BASIC }, PROPERTY_USAGE: { RENT }, NA } = require('../../insuranceConstants/insuranceRequestHome');

const buildTooltip = (label) => {
    return (
        <div className="insurance-request-compilation-card__tooltip-content">
            <FormattedText value={`insuranceRequestHome-${label}`} />
        </div>
    );
}

const formatCurrency = (amount, decimalsLength = 0) => {
    return getFormattedString({
        amount: amount,
        currency: EURO_TEXT,
        decimalsLength
    });
}

const insuranceRequestBuildContinentContentItem = (itemKey, label, immInsuranceWizardState, isRelated = false, hasSimulationChanged) => {
    const amount = immInsuranceWizardState.getIn(['steps', SECOND_STEP, itemKey]);
    let insurancePlan = '';
    let propertyUsage = '';
    let isUsagePropertyRentAndBasicPlan;
    if (!isRelated && itemKey === 'content') {
        insurancePlan = immInsuranceWizardState.getIn(['steps', THIRD_STEP, 'insurancePlan']);
        propertyUsage = immInsuranceWizardState.getIn(['steps', SECOND_STEP, 'propertyUsage']);
        isUsagePropertyRentAndBasicPlan = insurancePlan === BASIC && propertyUsage === RENT
    }
    let amountFormatted = formatText('insuranceRequestHome-summaryToBeDefined');

    if (!!amount) {
        amountFormatted = formatCurrency(amount);
    }

    return {
        label: formatText(`insuranceRequestHome-${label}`),
        text: isUsagePropertyRentAndBasicPlan && !hasSimulationChanged ? NA : amountFormatted,
        className: classnames({
            'insurance-request-compilation-card__text--disabled': !amount
        }),
        icon: 'icon-informacion',
        iconCustomClass: 'insurance-request-compilation-card__icon',
        tooltipClassName: 'insurance-request-compilation-card__tooltip',
        tooltipPlacement: 'top',
        tooltipOffset: [0, -10],
        information: buildTooltip(`${label}Tooltip`)
    };
}


module.exports = insuranceRequestBuildContinentContentItem;